module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('tooltip', {
    attrs: {
      "label": "Contacts",
      "type": "default",
      "placement": "left"
    }
  }, [_c('a', {
    staticClass: "button button-table is-small",
    on: {
      "click": function($event) {
        return _vm.contact()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-address-card"
  })])]), _vm._v(" "), _c('tooltip', {
    attrs: {
      "label": "Comments",
      "type": "default",
      "placement": "left"
    }
  }, [_c('a', {
    staticClass: "button button-table is-small",
    on: {
      "click": function($event) {
        return _vm.comments()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-comment-o"
  })])]), _vm._v(" "), _c('tooltip', {
    attrs: {
      "label": "History",
      "type": "default",
      "placement": "left"
    }
  }, [_c('a', {
    staticClass: "button button-table is-small",
    on: {
      "click": function($event) {
        return _vm.history()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-history"
  })])]), _vm._v(" "), (parseInt(_vm.$store.state.config.user.departament) === 2 || parseInt(_vm.$store.state.config.user.departament) === 0 || parseInt(_vm.$store.state.config.user.level) === 3) ? _c('tooltip', {
    attrs: {
      "label": "Rules",
      "type": "default",
      "placement": "left"
    }
  }, [_c('a', {
    staticClass: "button button-table is-small",
    on: {
      "click": function($event) {
        return _vm.editRules()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-cog"
  })])]) : _vm._e(), _vm._v(" "), _c('tooltip', {
    attrs: {
      "label": "Edit",
      "type": "default",
      "placement": "left"
    }
  }, [_c('a', {
    staticClass: "button button-table is-small",
    on: {
      "click": function($event) {
        return _vm.edit()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })])]), _vm._v(" "), _c('tooltip', {
    attrs: {
      "label": "Finances",
      "type": "default",
      "placement": "left"
    }
  }, [_c('a', {
    staticClass: "button button-table is-small",
    on: {
      "click": function($event) {
        return _vm.finances()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-usd"
  })])]), _vm._v(" "), _c('tooltip', {
    attrs: {
      "label": "Relationship",
      "type": "default",
      "placement": "left"
    }
  }, [_c('a', {
    staticClass: "button button-table is-small",
    on: {
      "click": function($event) {
        return _vm.relationship()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-handshake-o"
  })])]), _vm._v(" "), _c('tooltip', {
    attrs: {
      "label": "Call Log",
      "type": "default",
      "placement": "left"
    }
  }, [_c('a', {
    staticClass: "button button-table is-small",
    on: {
      "click": function($event) {
        return _vm.call()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-phone"
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b282c10","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/agencies/AgencyTableButtons.vue
// module id = 1138
// module chunks = 39